import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <p className="footer-title">Vix Algo Trading Store</p>
          <p className="footer-tagline">Precision tools for systematic traders.</p>
        </div>
        <div className="footer-links">
          <Link to="/contact-us" aria-label="Contact Us">Contact Us</Link>
          <Link to="/privacy-policy" aria-label="Privacy Policy">Privacy Policy</Link>
          <Link to="/terms-and-conditions" aria-label="Terms and Conditions">Terms & Conditions</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Vix Algo Trading Store. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
